import { useState } from 'react';
import { Select, Input, Chip, MenuItem, InputLabel } from '@mui/material';
import styled from 'styled-components';
import { Item } from '../types';
import { ALL_PENDING_MAPPING_STATUS } from '../constants';

const ChipContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%; /* Ensure consistent width handling */

  .helper-text {
    text-align: left;
    margin-bottom: 4px;
  }
`;

type ChipMultiSelectProps = {
  items: Item[];
  selectedItems: Item[];
  onItemSelect?: (chips: Item[]) => void;
  onClose: (chips: Item[]) => void;
  helperText?: string;
};

const MenuProps = {
  PaperProps: {
    style: {
      minWidth: 170,
      top: 200,
    },
  },
  variant: 'menu' as any,
  getContentAnchorEl: null,
};

/**
 * @deprecated
 * do not reuse, use MultiItemSelector instead
 */
const ChipMultiSelect = ({
  items = ALL_PENDING_MAPPING_STATUS,
  selectedItems,
  onClose,
  onItemSelect,
  helperText = 'chips',
}: ChipMultiSelectProps) => {
  const [chips, setChips] = useState(selectedItems);

  const onChange = (event: any) => {
    const nextStateChips = [...event.target.value];
    if (onItemSelect) {
      onItemSelect(nextStateChips);
    }
    setChips(nextStateChips);
  };

  const closeSelect = () => {
    onClose(chips);
  };

  return (
    <ChipContainer>
      <InputLabel className="helper-text" shrink htmlFor="select-multiple-native">
        {helperText}
      </InputLabel>
      <Select
        labelId="demo-mutiple-chip-label"
        id="demo-mutiple-chip"
        multiple
        value={chips}
        onChange={onChange}
        onClose={closeSelect}
        MenuProps={MenuProps}
        input={<Input id="select-multiple-chip" />}
        renderValue={(chips) => (
          <div>
            {chips.map((item) => (
              <Chip key={item.label} label={item.label} />
            ))}
          </div>
        )}
      >
        {items.map((item) => (
          <MenuItem key={item.label} value={item as any}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </ChipContainer>
  );
};

export default ChipMultiSelect;
